export function initSpeakerGrid(): void {
    const filterStrips = document.querySelectorAll<HTMLElement>('[data-speaker-grid-filter]')
    if (filterStrips.length === 0) return

    filterStrips.forEach((strip) => {
        const ceUid = strip.dataset.speakerGridFilter
        if (!ceUid) return

        const gridContainer = document.querySelector<HTMLElement>(`[data-speaker-grid="${ceUid}"]`)
        if (!gridContainer) return

        const chips = strip.querySelectorAll<HTMLButtonElement>('button.speaker-chip')

        chips.forEach((chip) => {
            chip.addEventListener('click', async (event) => {
                event.preventDefault()
                const url = chip.dataset.filterUrl
                if (!url) return

                if (gridContainer.getAttribute('aria-busy') === 'true') return

                chips.forEach((c) => {
                    c.setAttribute('aria-pressed', 'false')
                    c.classList.remove('chip-active', 'bg-secondary-900', 'text-white')
                    c.classList.add('bg-white', 'text-secondary-800', 'border', 'border-secondary-200')
                })
                chip.setAttribute('aria-pressed', 'true')
                chip.classList.add('chip-active', 'bg-secondary-900', 'text-white')
                chip.classList.remove('bg-white', 'text-secondary-800', 'border', 'border-secondary-200')

                gridContainer.setAttribute('aria-busy', 'true')
                gridContainer.style.opacity = '0.5'
                gridContainer.style.transition = 'opacity 150ms ease'

                try {
                    const response = await fetch(url, {
                        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html' },
                        credentials: 'same-origin',
                    })
                    if (!response.ok) throw new Error(`HTTP ${response.status}`)

                    const html = await response.text()
                    const parser = new DOMParser()
                    const doc = parser.parseFromString(html, 'text/html')
                    const filterResponse = doc.querySelector('[data-speaker-filter-response]')

                    if (filterResponse) {
                        gridContainer.innerHTML = filterResponse.innerHTML
                    } else {
                        gridContainer.innerHTML = html
                    }
                } catch (err) {
                    console.error('SpeakerGrid filter failed:', err)
                    gridContainer.innerHTML =
                        '<p class="col-span-full text-center text-secondary-600 py-12">Filter konnte nicht geladen werden. Bitte Seite neu laden.</p>'
                } finally {
                    gridContainer.setAttribute('aria-busy', 'false')
                    gridContainer.style.opacity = ''
                }
            })
        })
    })
}
